module.exports = __webpack_public_path__ + "img/test_Icon14.a8fc1deb.png";